export interface AuthUser {
  cxoneAgentId: string;
  username: string;
  displayName: string;
  tenantId: string;
  identityId: string;
}

export interface SapSessionApiResponse {
  success: boolean;
  data: {
    token: string;
    accessToken: string;
    expiresIn: number;
    userInfo?: {
      agentId?: string;
    };
    user: {
      identityId: string;
      tenantId: string;
      cxoneAgentId: string;
      username: string;
      displayName: string;
    };
  };
}

export interface ValidateResponse {
  success: boolean;
  data: {
    token?: string;
    accessToken: string;
    expiresIn: number;
    userInfo: {
      agentId?: string;
      [key: string]: unknown;
    };
    user: {
      identityId: string;
      tenantId: string;
      username: string;
      firstName: string;
      lastName: string;
      cxoneAgentId: string;
    };
  };
}

export interface RefreshResponse {
  accessToken: string;
  expiresIn: number;
  expiresAt: number;
}

export interface OidcBootstrapData {
  clientId: string;
  authHost: string;
  authorizeUrl: string;
  redirectUri: string;
  scope: string;
}

export function mapSessionUser(data: SapSessionApiResponse['data']): AuthUser {
  return {
    identityId: data.user.identityId,
    tenantId: data.user.tenantId,
    cxoneAgentId: data.user.cxoneAgentId || data.userInfo?.agentId || '',
    username: data.user.username,
    displayName: data.user.displayName,
  };
}

export type SessionResult = {
  user: AuthUser;
  accessToken: string;
  expiresIn: number;
  sessionToken: string;
};
